import { matchPath } from 'react-router-dom';
import { MenuItemType } from 'types';

export const buildBreadcrumbTrail = (menuItems: MenuItemType[], path: string): MenuItemType[] => {
  const trail: MenuItemType[] = [];

  const findTrail = (items: MenuItemType[], currentPath: string): boolean => {
    for (const item of items) {
      if (!item.path) continue;

      const isMatch = matchPath({ path: item.path, end: false }, currentPath);

      if (isMatch) {
        trail.push(item);

        if (item.children?.length) {
          if (findTrail(item.children, currentPath)) return true;
        }

        return true;
      }
    }

    return false;
  };

  findTrail(menuItems, path);
  return trail;
};
